import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
  Tooltip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Menu as MenuIcon, Logout as LogoutIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import LanguageThemeControls from "@/components/LanguageThemeControls";
import { DRAWER_WIDTH } from "./constants";

interface TopBarProps {
  onMenuToggle: () => void;
}

export default function TopBar({ onMenuToggle }: TopBarProps) {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
        ml: { md: `${DRAWER_WIDTH}px` },
      }}
    >
      <Toolbar>
        {!isDesktop && (
          <IconButton color="inherit" edge="start" onClick={onMenuToggle} sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>
        )}
        <Typography
          variant="h6"
          noWrap
          sx={{ flexGrow: 1, cursor: "pointer" }}
          onClick={() => navigate("/reviews")}
        >
          {t("app.title")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <LanguageThemeControls variant="appBar" />
          {user && (
            <Typography
              variant="body2"
              onClick={() => navigate("/account")}
              sx={{
                color: "inherit",
                display: { xs: "none", sm: "block" },
                ml: 1,
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              {user.email}
            </Typography>
          )}
          <Button
            color="inherit"
            size="small"
            startIcon={<LogoutIcon />}
            onClick={logout}
          >
            {t("auth.signOut")}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
